<template>
    <div>
        <b-form-group label-for="birthdate">
            <template slot="label"
                >{{ $t("pages.forms.common.birth-date.title")
                }}<span v-if="required" class="font-weight-bolder text-danger"
                    >*</span
                ></template
            >
            <template slot="description" v-show="!isReviewing"
                >{{ $t("pages.forms.common.birth-date.description1") }}
                <strong
                    ><i>{{
                        $t("pages.forms.common.birth-date.description2")
                    }}</i></strong
                ></template
            >
            <validation-provider
                slim
                :rules="{
                    required,
                    date: { minDate: setMinDate, maxDate: setMaxDate }
                }"
                v-slot="{ dirty, validated, valid, errors }"
            >
                <b-input-group v-show="!isReviewing">
                    <date-picker
                        id="birthdate"
                        v-model="birthdate"
                        :model-config="modelConfig"
                        mode="date"
                        :state="dirty || validated ? valid : null"
                        :required="required"
                        :min-date="setMinDate"
                        :max-date="setMaxDate"
                        :masks="masks"
                        @input="update"
                    >
                        <template v-slot="{ inputValue, inputEvents }">
                            <input
                                class="px-2 py-2 border rounded focus:outline-none focus:border-blue-300"
                                :value="inputValue"
                                v-on="inputEvents"
                                readonly
                            />
                        </template>
                    </date-picker>
                    <b-form-invalid-feedback
                        :state="dirty || validated ? valid : null"
                        >{{ errors[0] }}
                    </b-form-invalid-feedback>
                </b-input-group>
            </validation-provider>
            <b-form-input
                type="text"
                :value="birthdateWhenReviewing"
                :readonly="true"
                :plaintext="true"
                v-show="isReviewing"
            />
        </b-form-group>

        <b-form-group>
            <b-button
                v-show="!isReviewing"
                variant="secondary"
                v-b-modal.birthDateModal
                :centered="true"
                >{{ $t("pages.forms.common.birth-date.modal-button-text") }}
            </b-button>
            <b-modal
                id="birthDateModal"
                :title="$t('pages.forms.common.birth-date.modal-box-title')"
                title-tag="h5"
                :hide-footer="true"
            >
                <p>
                    {{ $t("pages.forms.common.birth-date.modal-box-text-1") }}
                </p>
                <p>
                    {{ $t("pages.forms.common.birth-date.modal-box-text-2") }}
                </p>
                <p>
                    {{ $t("pages.forms.common.birth-date.modal-box-text-3") }}
                </p>
                <img
                    src="../../../../../public/images/tutorial-calendar.gif"
                    class="img-fluid"
                    alt="Cómo usar el calendario"
                    style="margin: 10px;"
                />
            </b-modal>
        </b-form-group>
    </div>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import moment from "moment";

export default {
    components: { ValidationProvider, DatePicker },
    data() {
        return {
            birthdate: null,
            modelConfig: {
                type: "string",
                mask: "YYYY-MM-DD"
            },
            masks: {
                input: "DD-MM-YYYY"
            }
        };
    },
    props: {
        value: null,
        required: {
            type: Boolean,
            default: false
        },
        reviewing: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        update(value) {
            this.$emit("input", value);
        }
    },
    computed: {
        birthdateWhenReviewing() {
            if (this.birthdate != null) {
                return this.birthdate
                    .split("-")
                    .reverse()
                    .join("-");
            } else {
                return this.birthdate;
            }
        },
        isReviewing() {
            return this.reviewing;
        },
        setMinDate() {
            let today = new Date();
            return moment(today)
                .subtract(150, "years")
                .format("YYYY-MM-DD");
        },
        setMaxDate() {
            return moment(new Date())
                .add(1, "days")
                .format("YYYY-MM-DD");
        },
        monthLongNames() {
            return this.$t("date.long-names");
        }
    }
};
</script>
